export const tableDefaultState = {
  data: [],
  totalItems: 0,
  totalPages: 0,
  pageSize: 100,
  pageIndex: 0,
  sortBy: [],
}